import React from 'react';

export default props =>
<div>
</div>


// WEBPACK FOOTER //
// ./src/Components/Layouts/Footer.js